<template>
    <div class="tax-batch sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item>计算个税</el-breadcrumb-item>
            <el-breadcrumb-item>结算试算</el-breadcrumb-item>
        </el-breadcrumb>

        <div class="content-box" v-loading="uploading">
            <div class="pay-step text-center">
                <div class="tips">
                    <div class="hd">填写试算数据前请先下载模板</div>
                    <div class="bd">在模板中录入姓名、身份证号及结算金额，再上传进行税后试算。</div>
                    <a
                        class="ft"
                        href="https://jinsuizhiguan.oss-cn-beijing.aliyuncs.com/templet/%E6%89%B9%E9%87%8F%E8%AF%95%E7%AE%97%E6%A8%A1%E6%9D%BF.xlsx"
                        target="_blank"
                        rel="noopener noreferrer">
                        <img src="../../assets/img/icon-excel.png" alt="批量试算模板">
                        批量试算模板.xlsx
                        <el-button class="upload_link" type="text">下载</el-button>
                    </a>
                </div>
                <el-upload
                    class="upload-demo__huge"
                    :action="uploadAction"
                    :headers="headers"
                    drag
                    name="project_excel"
                    :before-upload="handleBeforeUpload"
                    :on-success="handleUploadSuccess"
                    :on-error="handleUploadError"
                    :limit="1"
                    accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
                    <i class="iconfont icon-shangchuanwenjian"></i>
                    <div class="el-upload__text">
                        点击此处上传录入完成的文件
                        <div class="btn-wraper">
                            <el-button type="primary">上传文件</el-button>
                        </div>
                    </div>
                </el-upload>
            </div>
        </div>
    </div>
</template>

<script>
const REQUEST_TYPE = 1

export default {
    name: 'TaxBatchUpload',
    data () {
        return {
            uploadAction: process.env.VUE_APP_BASE + '/api/user/project/uploadtaxtrialcalculation',
            headers: {},
            uploading: false
        }
    },
    mounted () {
        this.headers = { token: localStorage.getItem('token') }
    },
    methods: {
        handleBeforeUpload () {
            this.uploading = true
        },
        handleUploadSuccess (res) {
            this.uploading = false
            const data = res.data || {}
            if (res.code === 0 && data.fullpath) {
                const fullpath = data.fullpath
                this.$router.push({
                    path: '/index/tax/batch/result',
                    query: {
                        fullpath,
                        key: data.key || '',
                        name: data.name || '',
                        type: REQUEST_TYPE
                    }
                })
            } else {
                this.$message.error(res.message || '文件上传失败，请稍后重试')
            }
        },
        handleUploadError () {
            this.uploading = false
            this.$message.error('文件上传失败，请稍后重试')
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../assets/style/sub.scss";

.tax-batch {
    .content-box {
        background: #fff;
        padding: 24px;
        border-radius: 4px;
        box-shadow: 0 2px 6px rgba(31, 49, 108, 0.05);
        display: flex;
        justify-content: center;
    }

    .pay-step {
        width: 100%;
        max-width: 640px;
        margin: 0 auto;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;

        .tips {
            .hd {
                font-size: 18px;
                margin-top: 30px;
                font-weight: bold;
            }

            .bd {
                font-size: 16px;
                margin-top: 20px;
                color: #999;
            }

            .ft {
                font-size: 16px;
                cursor: pointer;
                margin: 40px 0;
                display: inline-flex;
                align-items: center;
                color: #303133;

                img {
                    height: 16px;
                    margin-right: 5px;
                    margin-bottom: 1px;
                    vertical-align: middle;
                }

                button {
                    margin-left: 15px;
                    font-size: 16px;
                }
            }
        }

        ::v-deep .upload-demo__huge {
            margin: 0 auto;
            display: inline-flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            max-width: 640px;

            .el-upload {
                width: 100%;
            }

            .el-upload-dragger {
                width: 100%;
                max-width: 640px;
            }
        }
    }
}
</style>
